// @flow

import React from 'react';
import { withTranslation } from 'react-i18next';

import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import { logGAEvent } from '../util/log-ga';
import JobDescription from './job-description';
import { addBodyModalClass, removeBodyModalClass } from '../util/modal';
import JobCompensation from './job-compensation';

const styles = () => ({
  viewJobDesc: {
    marginTop: '15px',
    cursor: 'pointer',
  },
});

type Props = {
  job: Object,
  org: Object,
  jobCompensation: Object | null,
  fullScreen: boolean,
  classes: Object,
  t: (value: string, opts?: any) => string,
};

type State = {
  modalOpen: boolean;
};

class Transition extends React.PureComponent<Props>{
  render() {
    // $flow-disable-next-line
    return <Slide direction="up" {...this.props} />;
  }
}

class JobDescriptionDialog extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      modalOpen: false,
    };
  }

  handleOpen = () => {
    addBodyModalClass();
    this.setState({
      modalOpen: true,
    });
    logGAEvent('Application', 'Viewed: Job Description');
  }

  handleClose = () => {
    removeBodyModalClass();
    this.setState({
      modalOpen: false,
    });
  }


  render() {
    const { job, jobCompensation, classes, t } = this.props;
    return (
      <div className={classes.container}>
        <Typography variant="body1" className={classes.viewJobDesc} gutterBottom onClick={this.handleOpen}>{t('viewJobDescription')}</Typography>
        <Dialog
          open={this.state.modalOpen}
          onClose={this.handleClose}
          fullScreen={this.props.fullScreen}
          TransitionComponent={Transition}
        >
          <DialogTitle id="form-dialog-title">
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                {job.title}
                  <JobCompensation
                    offeredCompensation={jobCompensation}
                    typographyClass={classes.headline}
                    variant="typography"
                    typographyVariant="subtitle1"
                  />
              </Grid>
              <Grid item>
                <Button onClick={this.handleClose} color="secondary">
                  {t('close')}
                </Button>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <JobDescription
              job={job}
              org={this.props.org}
              allowApply={false}
            />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(withMobileDialog()(JobDescriptionDialog)));
